import { StateField, type EditorState } from "@codemirror/state";
import { Decoration, EditorView, type DecorationSet } from "@codemirror/view";

export type StoryLineKind = "choice" | "option" | "condition" | "otherwise" | "effect";

/** Recognize the projection's human-readable labels, never rewrite authored text. */
export function storyLineKind(text: string): StoryLineKind | null {
  const line = text.trim();
  if (/^\[Choice\]$/.test(line)) return "choice";
  if (/^\[Option: .+\]$/.test(line)) return "option";
  if (/^\[If .+\]$/.test(line)) return "condition";
  if (/^\[Otherwise(?: — continue to .+)?\]$/.test(line)) return "otherwise";
  if (/^\[Effect: .+\]$/.test(line)) return "effect";
  return null;
}

function decorateStructure(state: EditorState): DecorationSet {
  const lines = [];
  for (let n = 1; n <= state.doc.lines; n++) {
    const line = state.doc.line(n);
    const kind = storyLineKind(line.text);
    if (kind) lines.push(Decoration.line({ class: `writing-structure writing-structure-${kind}` }).range(line.from));
  }
  return Decoration.set(lines);
}

export const storyStructure = StateField.define<DecorationSet>({
  create: decorateStructure,
  update: (decorations, transaction) => transaction.docChanged ? decorateStructure(transaction.state) : decorations,
  provide: (field) => EditorView.decorations.from(field),
});
